import { z } from "zod";
/**
 * The community board (`D276`): tips and ideas written by people, published
 * only after the owner approves each one, voted on by everyone, with no
 * count shown (`D263`'s reasons) and no author named.
 *
 * - `GET /me/community/posts` — the published posts with the caller's own
 *   vote, and the caller's own posts with their state.
 * - `POST /me/community/posts` — a tip or an idea; 201 new, 200 for a resend
 *   of the same id (`D163`), 409 `community.post_conflict` for an id another
 *   account holds. Born `pending`.
 * - `PUT` / `DELETE /me/community/posts/:postId/vote` — vote or withdraw;
 *   only a published post takes a vote (404 `community.post_not_found`).
 *
 * Online only, never the outbox (`D163`), like the rest of `D263`.
 */
export const COMMUNITY_BOARD_ROUTES = {
    posts: "/me/community/posts",
    vote: "/me/community/posts/:postId/vote",
};
export function communityPostVotePath(postId) {
    return `${COMMUNITY_BOARD_ROUTES.posts}/${encodeURIComponent(postId)}/vote`;
}
export const COMMUNITY_POST_KINDS = ["tip", "idea"];
const communityPostKind = z.enum(COMMUNITY_POST_KINDS);
const COMMUNITY_POST_STATUSES = ["pending", "approved", "rejected"];
const communityPostStatus = z.enum(COMMUNITY_POST_STATUSES);
export const COMMUNITY_POST_TEXT_MIN = 10;
export const COMMUNITY_POST_TEXT_MAX = 500;
/** `POST /me/community/posts`. `id` is the client's UUIDv7, minted when the
 *  form is drawn (`T-174`). */
export const communityPostInput = z.strictObject({
    id: z.uuid(),
    kind: communityPostKind,
    text: z
        .string()
        .trim()
        .min(COMMUNITY_POST_TEXT_MIN)
        .max(COMMUNITY_POST_TEXT_MAX),
});
export const communityPostOutput = z.object({
    id: z.uuid(),
    recordedAt: z.iso.datetime(),
    status: communityPostStatus,
});
const publishedPost = z.object({
    id: z.string(),
    kind: communityPostKind,
    text: z.string(),
    /** The caller's own vote; nobody's tally. */
    voted: z.boolean(),
});
const ownPost = z.object({
    createdAt: z.iso.datetime(),
    id: z.string(),
    kind: communityPostKind,
    status: communityPostStatus,
    text: z.string(),
});
export const boardOutput = z.object({
    mine: z.array(ownPost),
    published: z.array(publishedPost),
});
export const communityPostVoteOutput = z.object({
    postId: z.string(),
    voted: z.boolean(),
});
//# sourceMappingURL=board.js.map